export const uk = {
    cancel: 'Отмена',
    description: 'Описание продукта',
    save: 'Сохранить'
};
